<ng-template #tipContent>
  <ng-content></ng-content>
</ng-template>
<button
  *ngIf="!templateRef"
  type="button"
  class="btn"
  [ngbTooltip]="tipContent"
  [autoClose]="false"
  [tabindex]="tabIndex"
  [triggers]="trigger"
  [disabled]="disabled"
  [container]="container"
  tooltipClass="{{customTooltipClass()}}">
  {{title}}
  <i *ngIf="icon" class="material-icons">{{icon}}</i>
</button>
<ng-container *ngTemplateOutlet="templateRef; context: {$implicit: this}">
</ng-container>
